type SessionTimes = {
  start_time?: string | null
  charge_started_at?: string | null
  end_time?: string | null
  charge_finished_at?: string | null
}

const MIN_SESSION_TAIL_MS = 60_000

export const chargingUtils = {
  getMinimumAmount(activationFee: number, pendingBalance = 0): number {
    const activationCents = Math.max(1, Math.ceil(activationFee * 100 - 1e-8))
    return (activationCents + Math.round(Math.max(0, pendingBalance) * 100)) / 100
  },

  getSessionAmount(totalAmount: number, pendingBalance = 0): number {
    return Math.max(0, Math.round(totalAmount * 100) - Math.round(Math.max(0, pendingBalance) * 100)) / 100
  },

  getChargeStartTime(session: SessionTimes | null | undefined): string | null {
    return session?.charge_started_at ?? session?.start_time ?? null
  },

  getChargeEndTime(session: SessionTimes | null | undefined): string | null {
    return session?.charge_finished_at ?? session?.end_time ?? null
  },

  hasSessionTail(session: SessionTimes | null | undefined): boolean {
    if (!session?.charge_finished_at || !session?.end_time) return false

    const chargeEnd = new Date(session.charge_finished_at).getTime()
    const sessionEnd = new Date(session.end_time).getTime()
    if (isNaN(chargeEnd) || isNaN(sessionEnd)) return false

    return sessionEnd - chargeEnd >= MIN_SESSION_TAIL_MS
  },

  /**
   * kWh estimados para um valor de recarga, descontando a taxa de ativação antes de
   * dividir pela tarifa — a taxa é fixa, não energia. Sem isso a estimativa mostrada
   * ao motorista não bate com o que ele recebe (ver Plano 29).
   */
  getEquivalentKwh(amount: number, ratePerKwh: number, activationFee = 0): number {
    const amountAfterFee = Math.max(0, amount - activationFee)
    return amountAfterFee > 0 && ratePerKwh > 0 ? amountAfterFee / ratePerKwh : 0
  },
}
